export enum PriceOptionDropdownDataHooks {
  DROPDOWN = 'price-option-dropdown',
}
